import CommonDatePicker from "@/common/elements/DatePicker";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow, StyledSectionHeading } from "@/common/styles";
import { useState } from "react";

const LocateInformationForm = ({}) => {
    const [isRequiresReview,setIsRequiresReview] = useState(false);
    const handleRequiresReview = (checkbox) => {
        console.log("checkbox",checkbox)
        setIsRequiresReview(checkbox?.target?.checked)
    }
    return(
        <>
        <StyledSectionHeading marginTop="20px">
            <span>Locate Information</span>
        </StyledSectionHeading>

        <StyledGridRow gutter={16}>
            <StyledGridCol>
                <FormItem label="Extradition Area">
                    <Select />
                </FormItem>
            </StyledGridCol>

            <StyledGridCol>
                <FormItem label="Other Extradition Notes">
                    <Select />
                </FormItem>
            </StyledGridCol>

            <StyledGridCol>
                <FormItem label="Requires review?" 
                labelPostion="label-right"
                layout="horizontal" 
                paddingTop="24px">
                    <Checkbox onChange={handleRequiresReview}/>
                </FormItem>
            </StyledGridCol>
           
            { isRequiresReview && (
            <>
            <StyledGridCol>
                <FormItem label="Review Date">
                  <CommonDatePicker showTime={false} format="MM/DD/YYYY" />
                </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={6}>
                <FormItem label="Reviewed By">
                    <Select />
                </FormItem>
            </StyledGridCol>
            </>
           )}

          <StyledGridCol lg={12}>
                <FormItem label="Review Comments">
                    <TextField />
                </FormItem>
            </StyledGridCol>
          </StyledGridRow>

        </>
    )
}
export default LocateInformationForm;